// src/MaskedInput.js
import React from 'react';
import { IMaskInput } from 'react-imask';

const MaskedInput = React.forwardRef(function MaskedInput(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export default MaskedInput;